import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-payment-error",
  templateUrl: "./payment-error.component.html",
  styles: [],
  standalone: false,
})
export class PaymentErrorComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    
  }

  goToApp() {
    location.href = "myapp://app.estetistapp.it";
  }
}
